

const LenderFilterGranular = () => {


  const self = {
    init() {

      if (document.getElementsByClassName('LenderFilterGranular').length) {
        const load_elements = (payload) => {

          let type = payload.type.join(',');
          let url = '?filter=lg_lender&page_id=' + payload.page_id + '&type=' + type + '&sort=' + payload.sort;
        
          console.log(url);

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              document.querySelector('.c-lender_list__items').innerHTML = html;
            })
            .catch((error) => {
              console.warn(error);
            });
        }
      
        const onSortSelectChange = e => {
    
          var payload = { type: [], sort: [], page_id: [] }

          const filterValues = document
            .querySelectorAll('.LenderFilterGranular__filter')
        
          const sortValue = document
            .querySelector('.LenderFilterGranular__sort-select')

          payload.page_id = document.querySelector('.LenderFilterGranular').getAttribute('page-id');
          payload.sort = sortValue.value;
        
          filterValues.forEach(f => {
            if (f.checked) {
              payload.type.push(f.getAttribute('value'));
            }
          })
      
          load_elements(payload);
        

        }
      
    
        const filterToggle = document
          .querySelector('.LenderFilterGranular__filter-toggle');
      
        const typeSelect = document
          .querySelectorAll('.LenderFilterGranular__filter');
      
        const sortSelect = document
          .querySelector('.LenderFilterGranular__sort-select');
      
      
        typeSelect.forEach(el => el.addEventListener('click', e => {
          onSortSelectChange(e);
        }));

        sortSelect.addEventListener('change', e => {
          onSortSelectChange(e);
        });
      


        filterToggle.addEventListener('click', e => {
          filterToggle
            .closest('.LenderFilterGranular')
            .classList.toggle('has-visible-filters')
        });

      }
    }
  }

  return self
}

export default LenderFilterGranular


